import Vue from 'vue';
import {
   ValidationProvider, ValidationObserver, localize
} from 'vee-validate/dist/vee-validate.full';

Vue.component('ValidationProvider', ValidationProvider);
Vue.component('ValidationObserver', ValidationObserver);
